import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-secondary/5 to-background py-12 md:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full">
              <Icon name="Heart" size={20} color="var(--color-primary)" />
              <span className="text-primary font-semibold text-sm md:text-base">Our Story</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Bringing <span className="text-primary">Authentic Flavors</span> to South Sudan
            </h1>
            
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Founded in 2022, Chapati Plus was born from a simple dream: to serve delicious, quality fast food that celebrates South Sudanese culture while embracing modern convenience. We're more than just a restaurant—we're your neighborhood's trusted food destination.
            </p>
            
            <div className="flex flex-wrap gap-4 md:gap-6 pt-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Users" size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="text-xl md:text-2xl font-bold text-foreground">10,000+</p>
                  <p className="text-sm text-muted-foreground">Happy Customers</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-secondary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Award" size={24} color="var(--color-secondary)" />
                </div>
                <div>
                  <p className="text-xl md:text-2xl font-bold text-foreground">4+ Years</p>
                  <p className="text-sm text-muted-foreground">Of Excellence</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]">
              <Image
                src="https://i.ibb.co/spMdFSyt/Shop.jpg"
                alt="Warm interior of Chapati Plus restaurant showing wooden tables with red chairs, customers enjoying meals, and staff preparing fresh chapatis in open kitchen with traditional cooking equipment"
                className="w-full h-full object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white font-accent text-2xl md:text-3xl">Taste The Difference</p>
              </div>
            </div>
            
            <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-32 md:h-32 bg-accent rounded-full flex items-center justify-center shadow-xl">
              <div className="text-center">
                <p className="text-white font-bold text-xl md:text-2xl">4.8</p>
                <div className="flex gap-0.5 justify-center">
                  {[...Array(5)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={12} color="#FFFFFF" className="fill-white" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;